<template>
  <div>
    <div v-if="pageShow == ''" class="articlemanagement">
      <Card :bordered="false">
        <div slot="title">
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="2">
            <Divider orientation="left">{{ langMap.jobManagement[lang] }}</Divider>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="22">
            <Form :label-width="110">
              <div class="des-cardTittle-box">
                <FormItem :label="langMap.name[lang]" class="leftFlex">
                  <Input v-model.trim="name" :placeholder="langMap.name[lang]" clearable />
                </FormItem>

                <FormItem :label="langMap.status[lang]" class="leftFlex">
                  <Select v-model="status" clearable>
                    <Option :key="item.id" :value="item.id" v-for="item in statusList">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem :label="langMap.belongStation[lang]" class="leftFlex">
                  <Select v-model="queryStationId" clearable>
                    <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <Button type="info" style="margin-left:20px;" @click="searchData">{{ langMap.search[lang] }}</Button>
                <Button type="primary" style="margin-left:20px;" @click="modelShow(true, null)">{{ langMap.add[lang] }}</Button>
              </div>
            </Form>
            </Col>
          </Row>
        </div>
        <Table :height="height" :loading="tableLoading" border :columns="col" :data="robotList"></Table>
        <!--分页数据-->
        <div style="text-align:center;padding-top:10px;" v-if="robotList.length > 0">
          <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
        </div>
      </Card>
      <!--弹框表单-->
      <Modal :mask-closable="false" v-model="saveModal" :title="langMap.jobInfo[lang]">
        <Form ref="formValidate" :model="saveForm" :rules="ruleValidate" :label-width="80">
          <FormItem :label="langMap.name[lang]" prop="name">
            <Input v-model="saveForm.name" :placeholder="langMap.inputName[lang]" />
          </FormItem>
          <!--NEW ADD-->
          <FormItem :label="langMap.belongStation[lang]" prop="stationId">
            <Select v-model="saveForm.stationId" :disabled="opType === 'edit'">
              <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="langMap.description[lang]">
            <Input v-model="saveForm.description" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
              :placeholder="langMap.taskDescription[lang]" />
          </FormItem>
          <!-- 添加原始区域字段，仅在编辑模式下显示 -->
          <FormItem :label="langMap.originalPath[lang]" v-if="saveForm.id">
            <div class="copy-area-container">
              <Input
                v-model="saveForm.originalArea"
                disabled
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6 }"
              />
              <Button
                size="small"
                type="text"
                icon="ios-copy"
                class="copy-btn"
                :title="langMap.copy[lang]"
                @click="copyToClipboard(saveForm.originalArea)"
                v-if="saveForm.originalArea"
              ></Button>
            </div>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="text" :loading="btnLoading" @click="cancel">{{ langMap.cancel[lang] }}</Button>
          <Button type="primary" :loading="btnLoading" @click="ok">{{ langMap.save[lang] }}</Button>
        </div>
      </Modal>

      <!--导入路径弹框-->
      <Modal :mask-closable="false" v-model="importModal" :title="langMap.importPath[lang]">
        <Form ref="importFormRef" :model="importForm" :rules="importRule" :label-width="80">
          <FormItem :label="langMap.fileImport[lang]">
            <fileSelect @change="fileChange" /><span style="font-size: 12px;color:#87888a;">{{ langMap.supportFiles[lang] }}</span>
          </FormItem>
          <FormItem :label="langMap.collectionData[lang]" prop="body">
            <div class="data-input-container">
              <Input v-model="importForm.body" type="textarea" :placeholder="importPlaceHolder" class="scrollbar-g"
                :autosize="{ minRows: 4, maxRows: 8 }" />
              <div class="button-group">
                <Button
                  size="small"
                  type="primary"
                  icon="ios-copy"
                  @click="copyExample"
                >{{ langMap.copyExample[lang] || langMap.copy[lang] + langMap.example[lang] }}</Button>
                <Button
                  size="small"
                  type="primary"
                  icon="ios-code"
                  @click="formatJson"
                >{{ langMap.formatJsonButton[lang] }}</Button>
              </div>
            </div>
          </FormItem>
          <Alert type="warning">
            <b>{{ langMap.tips[lang] }}：</b><br />{{ langMap.importTip1[lang] }}
            <br />{{ langMap.importTip2[lang] }}<br />{{ langMap.importTip3[lang] }}
          </Alert>
        </Form>
        <div slot="footer">
          <Button type="text" :loading="btnLoading" @click="importModal = false">{{ langMap.cancel[lang] }}</Button>
          <Button type="primary" :loading="btnLoading" @click="saveImport">{{ langMap.save[lang] }}</Button>
        </div>
      </Modal>

    </div>
    <task-plan v-if="pageShow == 'plan'" v-on:changePageShow="this.changePageShow" :taskData="taskData" />
  </div>
</template>

<script>
import api from "../../../api/index.js";
import TaskPlan from "./taskPlanIndex";
import { readJsonFile } from '@/utils/index.js';
import langMap from '@/utils/language';
import { mapState } from 'vuex';

const validStation = (rule, value, callback,language) => {
  if (!value && value !== 0) {
    callback(new Error(langMap.stationRequired[language]));
  } else {
    callback();
  }
};

// 导入数据校验
const validJsonData = (rule, value, callback,language) => {
  if (!value) {
    callback(new Error(langMap.collectDataRequired[language]));
  } else {
    try {
      JSON.parse(value);
      callback();
    } catch (er) {
      callback(new Error(langMap.jsonFormatError[language]));
    }
  }
}

export default {
  components: {
    TaskPlan,
    fileSelect: () => import('@/components/fileSelect/index.vue')
  },
  data() {
    const _this = this;
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      taskData: {},
      pageShow: "",
      statusList: [],
      typeList: [],
      btnLoading: false,
      saveModal: false, // 表单弹框状态
      importModal: false, // 导入路径的弹框状态
      robotList: [],
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      status: "",
      name: "",
      queryStationId: '', // 查询用站点id
      // 弹框操作类型（add/edit）
      opType: 'add',
      // 采集数据示例
      importPlaceHolder:JSON.stringify({
        "coordinateType": "WGS84",
        "path":[{
          "lat": 30.262776,
          "lng": 120.123748,
          "mode": 1,
          "name": this.$store.state.app.language == "en" ? "Starting point" : "开始站点"
        },
        {
          "lat": 30.262776,
          "lng": 120.123748,
          "mode": 0,
          "name": this.$store.state.app.language == "en" ? "Node 2" : "节点2"
        },
        {
          "lat": 30.262776,
          "lng": 120.123748,
          "mode": 2,
          "name": this.$store.state.app.language == "en" ? "Terminal station" : "终止站点"
        }]
      }),
      // 导入路径使用的表单
      importForm: {
        body: ''
      },
      saveForm: {
        id: "",
        name: "",
        description: "",
        stationId: ""
      },
      // 归属点列表
      stationList: [],

    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language
    }),
    stationMap() {
      const _map = {};
      this.stationList.forEach(s => {
        _map[s.id] = s.name;
      });
      return _map;
    },
    ruleValidate(){
      return {
        name: [{ required: true, message: langMap.nameRequired[this.lang], trigger: "blur" }],
        stationId: [{ required: true, validator:(rule, value, callback) => validStation(rule, value, callback, this.lang), trigger: 'change' }]
      }
    },
    importRule(){
      return {
        body: [{ required: true, validator: (rule, value, callback) => validJsonData(rule, value, callback, this.lang), trigger: "blur" }]
      }
    },
    col(){
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title:  langMap.name[this.lang],
          minWidth: 150,
          key: "name",
          render: (h, { row }) => {
            let text = row.name;
            return h("div", {style: {textAlign: "left"}}, text);
          }
        },
        {
          title:  langMap.status[this.lang],
          key: "status",
          minWidth: 90,
          render(h, params) {
            var text = params.row.statusStr;
            var color = "";
            if (params.row.status == 1) {
              color = "blue";
            } else if (params.row.status == 2) {
              color = "red";
            } else if (params.row.status == 3) {
              color = "green";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.belongStation[this.lang],
          width: 180,
          key: "stationId",
          render:(h, { row }) => {
            return h('span', this.stationMap[row.stationId])
          }
        },
        {
          title: langMap.description[this.lang],
          minWidth: 180,
          key: "description",
          render: (h, { row }) => {
            let text = row.description;
            return h("div", {style: {textAlign: "left"}}, text);
          }
        },
        {
          title: langMap.createTime[this.lang],
          width: 180,
          key: "createTime",
          render(h, params) {
            var text = "";
            if (params.row.createTime) {
              text = params.row.createTime;
            } else {
              text = "-";
            }
            return h("span", text);
          }
        },
        {
          title: langMap.updateTime[this.lang],
          width: 180,
          key: "updateTime",
          render:(h, params) =>{
            var text = "";
            if (params.row.updateTime) {
              text = params.row.updateTime;
            } else {
              text = langMap.noModify[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.operation[this.lang],
          width: 220,
          align: "center",
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "2px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.modelShow(true, params.row);
                    }
                  }
                },
                langMap.modify[this.lang]
              )
            );
            //if (params.row.status == 1) { }
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "2px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDelete[this.lang],
                        okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "task-server/path/delete/" + params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );

            if (params.row.status == 2) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "ios-checkmark-circle"
                    },
                    style: {
                      marginLeft: "5px",
                      fontSize: "18px",
                      color: "#19be6b"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: langMap.confirmEnable[this.lang],
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "task-server/path/enable/" + params.row.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  langMap.enable[this.lang]
                )
              );
            }
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "2px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      /*this.$router.push({
                        path: '/task/taskPlan',
                        query: {id: params.row.id, name: params.row.name},
                      });*/
                      this.taskData = params.row;
                      this.pageShow = "plan";
                    }
                  }
                },
                langMap.pathPlanning[this.lang]
              )
            );

            // 导入路径
            renderArray.push(h("Divider", {
              props: {
                type: "vertical"
              },
              style: {
                margin: "0 2px"
              }
            }));
            renderArray.push(h('Button', {
              props: {
                type: "text"
              },
              style: {
                padding: "2px",
                color: "#2d8cf0"
              },
              on: { click: () => { this.openIportModal(params.row); } }
            }, langMap.importPath[this.lang]));

            return h("div", renderArray);
          }
        }
      ]
    }
  },
  methods: {
    //获取列表
    getList() {
      const _sid = `&stationId=${this.queryStationId || ''}`;
      this.tableLoading = true;

      api
        .getData(
          "task-server/path/list?index=" +
          this.index +
          "&status=" +
          (this.status || "") +
          "&name=" +
          this.name + _sid,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.robotList = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    getStationList() {
      api.getData('task-server/robotStation/list/all', this).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg,
          });
        } else {
          if (res.data) {
            this.stationList = res.data || [];
          }
        }
      })
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    modelShow(flag, data) {
      if (data) {
        this.opType = 'edit';
        this.saveForm = { ...data };
      } else {
        this.opType = 'add';
        this.saveForm = {
          id: "",
          name: "",
          description: ""
        };
      }

      this.saveModal = flag;
      this.$refs["formValidate"].resetFields();
    },
    ok() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          api.postData("task-server/path/save", this.saveForm, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.promptFromSystem[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.promptFromSystem[this.lang],
                  desc: langMap.operationSuccess[this.lang]
                });
                this.getList();
                this.saveModal = false;
              }
            }).finally(() => this.btnLoading = false);;
        }
      });
    },
    cancel() {
      //this.$Message.info('Clicked cancel');
      this.saveModal = false;
    },
    // 选择文件后触发
    fileChange(files) {
      readJsonFile(files[0]).then(res => {
        this.importForm.body = res;
      });
    },
    // 保存导入表单
    saveImport() {
      this.$refs["importFormRef"].validate(valid => {
        if (!valid) return;
        this.btnLoading = true;

        let { body, row } = this.importForm;
        body = body.replace(/\r/g, '').replace(/\n/g, '').replace(/\t/g, '').replace(' ', '').replace(/\s/g, '');
        let sendData = JSON.parse(body);
        sendData.pathId = row.id;

        api.postData("task-server/node/import", sendData, this).then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            this.$Notice.success({
              title: langMap.promptFromSystem[this.lang],
              desc: langMap.operationSuccess[this.lang]
            });
            this.getList();
            this.importModal = false;
          }
        }).finally(() => this.btnLoading = false);
      });
    },
    // 打开导入表单弹框
    openIportModal(row) {
      this.importModal = true;
      this.importForm = { body: '', row: row };
    },
    getDic() {
      api.getData("task-server/path/get/dic", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tips[this.lang],
            desc: res.msg
          });
        } else {
          this.statusList = res.data.status;
          this.typeList = res.data.type;
        }
      });
    },
    // 关闭页面
    changePageShow(i) {
      this.pageShow = i;
      this.getList();
    },
    // 添加复制功能
    copyToClipboard(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$Notice.success({
        title: langMap.tips[this.lang],
        desc: langMap.copySuccess[this.lang]
      });
    },
    // 复制采集数据示例
    copyExample() {
      this.copyToClipboard(this.importPlaceHolder);
    },
    // 格式化JSON数据
    formatJson() {
      try {
        if (!this.importForm.body) {
          this.$Notice.warning({
            title: langMap.tips[this.lang],
            desc: langMap.inputDataFirst[this.lang]
          });
          return;
        }
        // 解析并格式化JSON
        const jsonObj = JSON.parse(this.importForm.body);
        this.importForm.body = JSON.stringify(jsonObj, null, 2);
        this.$Notice.success({
          title: langMap.tips[this.lang],
          desc: langMap.formatSuccess[this.lang]
        });
      } catch (error) {
        this.$Notice.error({
          title: langMap.tips[this.lang],
          desc: langMap.jsonFormatError[this.lang]
        });
      }
    }
  },
  created() {
    this.getDic();
    this.getList();
    this.getStationList();
  }
};
</script>

<style>
/* 添加复制按钮样式 */
.copy-area-container {
  position: relative;
}

.copy-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}

.data-input-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.button-group {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
</style>
